<section class="view-edit-card">
  <app-page-content>
    <ng-container title *ngIf="!viewMode">{{ "Customers.Receivers.EditReceiver" | translate }} {{ "(" + selectedReceiver.name + ")" }}</ng-container>
    <ng-container title *ngIf="viewMode">
      {{ "Customers.Receivers.ReceiverDetails" | translate }}
      <span *ngIf="selectedReceiver?.name">{{ "(" + selectedReceiver.name + ")" }}</span>
    </ng-container>

    <app-state-section content [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
      <!-- view receiver -->
      <ng-container *ngIf="viewMode">
        <mat-card class="info-card">
          <mat-card-header class="info-card-header flex row">
            <mat-card-title class="title">{{ "Customers.Receivers.BasicInformation" | translate }}</mat-card-title>

            <div
              *grantAccess="RolesConstants.CUSTOMER_EDIT.concat(RolesConstants.GLOBAL_RECEIVER_EDIT);
             onlyIf: !readOnly && (receiverType === types.Customer || receiverType === types.General)"
              class="flex row edit"
              (click)="onEditButtonClicked()"
            >
              <img src="../../../../../assets/images/edit.svg" />
              <span>{{ "Buttons.Edit" | translate }}</span>
            </div>
          </mat-card-header>

          <mat-divider class="pos-static my-5"></mat-divider>
          <mat-card-content>
            <ng-container>
              <div class="basic-info-wrapper">
                <div class="company-name">
                  <span class="label">{{ "Inputs.CompanyName" | translate }}</span>
                  <p class="data">{{ selectedReceiver.name }}</p>
                </div>

                <div class="contact-info-wrapper">
                  <ng-container *ngFor="let contact of selectedReceiver.contactPerson">
                    <div class="contact-info">
                      <div>
                        <span class="label">{{ "Inputs.ContactName" | translate }}</span>
                        <p class="data">{{ contact.fullName() }}</p>
                      </div>

                      <div>
                        <span class="label">{{ "Inputs.MobileNumber" | translate }}</span>
                        <p class="data" [ngClass]="{ 'no-data': !contact.mobileNumber}" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">
                          <ng-container *ngIf="contact.mobileNumber">{{ contact.mobileNumber }}</ng-container>
                        </p>
                      </div>

                      <div>
                        <span class="label">{{ "Inputs.Email" | translate }}</span>
                        <p class="data" [ngClass]="{ 'no-data': !contact.email}">
                          <ng-container *ngIf="contact.email">{{ contact.email }}</ng-container>
                        </p>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </mat-card-content>
        </mat-card>

        <app-row class="mt-8">
          <app-locations-list
            [item]="selectedReceiver"
            [locations]="selectedReceiver?.locations"
            [type]="LocationType.Receiver"
            [readOnly]="readOnly"
            (navigateToMap)="onNavigateToMap($event)"
          ></app-locations-list>
        </app-row>

        <mat-card class="location-card">
          <mat-card-content>
            <div id="locationsCard">
              <app-locations
                [generalReceiver]="generalReceiver"
                [title]="'Customers.Receivers.ReceiverLocation' | translate"
                [locations]="selectedReceiver.locations"
                [item]="selectedReceiver"
                [type]="LocationType.Receiver"
                [viewMode]="viewMode"
                [enableLocationsView]="false"
                [selectedMapLocation]="selectedMapLocation"
              ></app-locations>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>

      <ng-container *ngIf="!viewMode">
        <mat-card class="card" content>
          <mat-card-content class="card-content" *ngIf="form">
            <div class="basic-info">
              <h3 class="title">{{ "Customers.Receivers.BasicInformation" | translate }}</h3>

              <div class="form-container" *ngIf="countries.length">
                <form class="form-group flex column justify-flex-start align-flex-start" [formGroup]="form">
                  <!-- company name -->
                  <div class="flex column form-control full-width">
                    <mat-label>{{ "Inputs.CompanyName" | translate }}</mat-label>
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        [placeholder]="
                          'Placeholder.EnterCompanyName' | translate
                        "
                        formControlName="companyName"
                      />
                      <mat-error
                        *ngIf="
                          form.invalid &&
                          form.get('companyName').touched &&
                          form.get('companyName').hasError('required')
                        "
                      >
                        {{ "ErrorMessages.Required" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div
                    style="width: 100%"
                    formArrayName="contacts"
                    *ngFor="
                      let contact of form.get('contacts')['controls'];
                      let i = index
                    "
                  >
                    <div [formGroupName]="i">
                      <div class="contact-fields flex row">
                        <!-- first name -->
                        <div class="flex column partial-width">
                          <mat-label>{{ "Inputs.FirstName" | translate }}</mat-label>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              type="text"
                              [placeholder]="
                                'Placeholder.EnterFirstName' | translate
                              "
                              formControlName="firstName"
                            />
                            <mat-error
                              *ngIf="
                                contact.invalid &&
                                contact.get('firstName').touched &&
                                contact.get('firstName').hasError('required')
                              "
                            >
                              {{ "ErrorMessages.Required" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <!-- last name -->
                        <div class="flex column partial-width">
                          <mat-label>{{ "Inputs.LastName" | translate }}</mat-label>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              type="text"
                              [placeholder]="
                                'Placeholder.EnterLastName' | translate
                              "
                              formControlName="lastName"
                            />
                            <mat-error
                              *ngIf="
                                contact.invalid &&
                                contact.get('lastName').touched &&
                                contact.get('lastName').hasError('required')
                              "
                            >
                              {{ "ErrorMessages.Required" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <!-- email -->
                        <div class="form-control flex column partial-width">
                          <mat-label>{{ "Inputs.Email" | translate }}</mat-label>
                          <mat-form-field appearance="outline">
                            <input matInput type="text" [placeholder]="'Placeholder.Email' | translate" formControlName="email" />
                            <mat-error
                              *ngIf="
                                contact.invalid &&
                                contact.get('email').touched &&
                                contact.get('email').hasError('invalidEmail')
                              "
                            >
                              {{ "ErrorMessages.InvalidEmail" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>

                        <!-- mobile -->
                        <div class="form-control flex column partial-width">
                          <mat-label>{{ "Inputs.MobileNumber" | translate }}</mat-label>

                          <div class="mobile-group flex row">
                            <!-- code -->
                            <mat-form-field class="select-options" appearance="outline">
                              <mat-select formControlName="countryCode">
                                <mat-option *ngFor="let country of countries" [value]="country.phoneKey">{{ country.phoneKey }}</mat-option>
                              </mat-select>

                              <mat-error
                                *ngIf="
                                  contact.invalid &&
                                  contact.get('countryCode').touched &&
                                  contact
                                    .get('countryCode')
                                    .hasError('required')
                                "
                              >
                                {{ "ErrorMessages.Required" | translate }}
                              </mat-error>
                            </mat-form-field>

                            <mat-form-field class="input-field" appearance="outline">
                              <input
                                matInput
                                type="text"
                                [placeholder]="
                                  'Placeholder.MobileNumber' | translate
                                "
                                formControlName="mobile"
                              />
                              <mat-error
                                *ngIf="
                                contact.invalid &&
                                contact.get('mobile').touched &&
                                  (contact.get('mobile').hasError('whitespace') ||
                                  contact.get('mobile').hasError('invalidPhoneNumber'))"
                              >
                                {{ "ErrorMessages.InvalidPhone" | translate }}
                              </mat-error>
                              <mat-error
                                *ngIf="
                                contact.invalid &&
                                contact.get('mobile').touched &&
                                (contact.get('mobile').hasError('invalidPhoneNumberLength'))"
                              >
                                {{ "ErrorMessages.InValidMobileLength" | translate: {length: MobileLengthPerCode[contact.get('countryCode').value]} }}
                              </mat-error>
                              <mat-error
                                *ngIf="
                                form.invalid &&
                                contact.get('mobile').touched &&
                                (contact.get('mobile').hasError('invalidPhoneNumberType'))"
                              >
                                {{ "ErrorMessages.invalidPhoneNumberType" | translate }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="add-contact-btn">
                  <img src="../../../../../assets/images/add.svg" />
                  <p (click)="addContact()">{{ "Buttons.AddAnotherContactPerson" | translate }}</p>
                </div>
              </div>
            </div>

            <div class="location">
              <app-locations
                (locationId)="onAddLocationId($event)"
                [title]="'Customers.Receivers.ReceiverLocation' | translate"
                [locations]="selectedReceiver.locations"
                [item]="selectedReceiver"
                [type]="LocationType.Receiver"
                [viewMode]="viewMode"
                [enableLocationsView]="false"
                [selectedMapLocation]="selectedMapLocation"
              ></app-locations>
            </div>

            <div class="action flex row">
              <button mat-raised-button class="btn-secondary btn" (click)="onCancelButtonClicked()">{{ "Buttons.Cancel" | translate }}</button>

              <button mat-raised-button class="btn-primary btn" (click)="onSaveButtonClicked()" [disabled]="form.invalid || !locationIds.length">
                {{ "Buttons.Save" | translate }}
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </app-state-section>
  </app-page-content>
</section>
